type BuildUpgradeUrlOpts = {
  currentPlanName: string;
  upgradePlanName: string;
  interval: 'month' | 'year';
};
export const buildUpgradeUrl = (opts: BuildUpgradeUrlOpts) => {
  const currentPlanName = (opts.currentPlanName || '').toLowerCase();
  const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
  const url =
    currentPlanName && upgradePlanName
      ? `/app/billing/plans/upgrade/${currentPlanName}/${upgradePlanName}?interval=${
          opts.interval || 'month'
        }`
      : '/app/billing/plans';
  return encodeURI(url);
};

export const formatPrice = (usdPennies: number) => {
  const dollars = usdPennies / 100;
  return dollars.toLocaleString('en-us', {
    minimumFractionDigits: dollars % 1 ? 2 : 0,
    maximumFractionDigits: 2,
  });
};
